import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { useFornecedores } from "../../services";
import { Fornecedores } from "../../types";
import { memoObserver } from "../../utils/memoObserver.utils";
import { useStores } from "../contexts/store-provider.context";
import { CModal } from "../data-display";
import {
  FormFornecedores,
  FormFornecedoresRef,
} from "./form-fornecedores.component";

export interface ModalEditFornecedoresProps {
  id: string;
}

export const ModalEditFornecedores = memoObserver(
  ({ id }: ModalEditFornecedoresProps) => {
    const { updateFornecedor, getFornecedor } = useFornecedores();
    const formRef = React.useRef<FormFornecedoresRef>(null);
    const [open, setOpen] = useState(false);
    const { fornecedoresStore } = useStores();

    const onSubmit = async (values: Fornecedores) => {
      try {
        updateFornecedor(values);
      } catch (err) {
        console.log(err);
      } finally {
        handleClose();
      }
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton
          onClick={() => {
            setOpen(true);
            getFornecedor(id);
          }}
        >
          <EditIcon />
        </IconButton>
        <CModal
          title="Editar Fornecedor"
          onSave={() => {
            formRef.current?.submit();
          }}
          open={open}
          onClose={() => handleClose()}
        >
          <FormFornecedores
            ref={formRef}
            onSubmit={onSubmit}
            loading={fornecedoresStore.crudLoading["edit"]}
            initialValues={fornecedoresStore.selectedData}
          />
        </CModal>
      </>
    );
  }
);
